module.exports = __webpack_public_path__ + "f37116b8343378b19f5fc7c2c439c92a.png";